import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { terraProxyApiClient } from '../../clients/testerClient';

type UseSignalsPreviewProps = {
  applicationId: string;
};

type Signal = {
  id: string;
  category?: string;
  description?: string | null;
  analysis?: string | null;
};

export function useSignalsPreview({ applicationId }: UseSignalsPreviewProps): {
  signals: Signal[];
} {
  const query = useQuery({
    queryKey: ['signals-preview', applicationId],
    queryFn: async (): Promise<Signal[]> => {
      if (!applicationId) {
        return [];
      }

      const result = await terraProxyApiClient.getSignalsByApplication(
        applicationId,
        {
          pagination: { skip: 0, limit: 1000 },
        },
      );

      return (result?.signals ?? []) as Signal[];
    },
    enabled: !!applicationId,
    staleTime: 30000,
  });

  const signals = useMemo(() => query.data ?? [], [query.data]);

  return { signals };
}
